import { PopoverButton } from '@headlessui/react';
import clsx from 'clsx';

// Types
import type { SocialProfileType } from '@/types/socialProfileType';

// Components
import { PopoverContainer, PopoverWrapper } from '@/components/base/Popover';
import type { SelectedProfilesProps } from '@/components/composite/SelectedProfiles';
import { PopoverContent } from '@/components/composite/SelectedProfiles/ProfilesList/AdditionalProfilesPopover/PopoverContent';

type AdditionalProfilesPopoverProps = Required<SelectedProfilesProps> & {
    profiles: SocialProfileType[];
    updateActive: (profile: SocialProfileType) => void;
};

export function AdditionalProfilesPopover({
    profiles,
    itemsSize,
    updateActive
}: AdditionalProfilesPopoverProps) {
    return (
        <PopoverWrapper
            popperOptions={{
                placement: 'right-start',
                offset: [4, 4],
                modifiers: [
                    {
                        name: 'flip',
                        options: {
                            fallbackPlacements: ['bottom-end']
                        }
                    }
                ]
            }}>
            {({
                open,
                setReferenceElement,
                referenceElement,
                setPopperElement,
                styles,
                attributes
            }) => {
                return (
                    <>
                        <PopoverButton
                            className={clsx(
                                'text-xs sm:text-sm',
                                'bg-icoBlue-100 text-icoBlue dark:bg-icoBlue/20',
                                'flex h-9 w-9 items-center justify-center rounded-full',
                                'border-2 border-white dark:border-icoDarkMode-deepBlack',
                                'focus:ring-0 focus:ring-offset-0',
                                {
                                    'sm:h-11.5 sm:w-11.5': itemsSize === 'base'
                                }
                            )}
                            ref={setReferenceElement}>
                            +{profiles.length}
                        </PopoverButton>
                        <PopoverContainer
                            open={open}
                            setPopperElement={setPopperElement}
                            styles={styles}
                            attributes={attributes}>
                            <PopoverContent
                                profiles={profiles}
                                updateActive={(profile) => {
                                    updateActive(profile);
                                    referenceElement.click();
                                }}
                            />
                        </PopoverContainer>
                    </>
                );
            }}
        </PopoverWrapper>
    );
}
